export default __webpack_public_path__ + "static/media/dribbleFooter.4e4e3611.svg";